var React = require('react');

function GreenCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector 1","d":"M0.500473 4.5L3.49953 7L8.49953 1","stroke":"#110923","strokeWidth":"1.5"}));
}

GreenCheckmark.defaultProps = {"width":"10","height":"9","viewBox":"0 0 10 9","fill":"none"};

module.exports = GreenCheckmark;

GreenCheckmark.default = GreenCheckmark;
